import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Flex from '@components/Flex';
import Toast from '../Toast';

const StyledMain = styled(Flex)`
  flex-grow: 1;
  flex-direction: column;
  height: 100%;
`;

function Main({ children, notification }) {
  return (
    <StyledMain role="main">
      {children}
      <Toast
        title={notification.title}
        color={notification.color}
        show={notification.show}
      />
    </StyledMain>
  );
}

Main.propTypes = {
  children: PropTypes.node.isRequired,
  notification: PropTypes.shape({
    show: PropTypes.bool,
    title: PropTypes.string,
    color: PropTypes.string,
  }).isRequired,
};

export default Main;
